
window.onload = function () {
	$("body").fadeIn(1000);
}

$(function(){
	const alert = $('.c-alert__product');

	 // aimation呼び出し
	 if ($('.js__alert-trigger').length) {
        scrollAnimation();
    }
	// aimation関数
    function scrollAnimation() {
        $(window).scroll(function () {
            $(".js__alert-trigger").each(function () {
                let position = $(this).offset().top,
                    scroll = $(window).scrollTop(),
                    windowHeight = $(window).height();

                if (scroll > position - windowHeight + 200) {
                    $(".c-alert__product").addClass('is-active');
                }
            });
			
			let el = ($('.js__alert-off').offset()||{"top":Number.MAX_SAFE_INTEGER})["top"];
			let scroll = $(this).scrollTop();
			if (scroll > el - $(window).height() - 200) {
				$(".c-alert__product").removeClass("is-active");
			}

        });
    }
    $(window).trigger('scroll');
  });
